/**
 * A është ky punëtor aktiv — një përgjigje, jo dhjetë.
 *
 * ── Pse ekziston ────────────────────────────────────────────────────────────
 * Kontrolli `w.Active !== false && w.active !== false` ishte kopjuar në dhjetë
 * skedarë dhe MUNGONTE në njëzet të tjerë. Pasoja dukej te çdo raport: njerëz
 * të larguar vite më parë rrinin te listat rënëse, te rosteret dhe te numrat e
 * ekipit, sikur të vinin nesër në punë.
 *
 * Dy emra për të njëjtën fushë sepse rreshti vjen ose nga API-ja (`Active`,
 * PascalCase si gjithë fusha e `workerFromDb`) ose drejt nga një `SELECT *`
 * (`active`). Kush kontrollon vetëm njërin, e lëshon gjysmën e rasteve.
 *
 * ── Rregulli i mospërcaktuarës ──────────────────────────────────────────────
 * Mungesa e fushës do të thotë AKTIV, jo joaktiv: kolona te baza ka
 * `DEFAULT true`, dhe një listë që fshihet sepse fusha s'u kthye do të ishte
 * dëm më i madh se një joaktiv i shfaqur.
 *
 * ── Ku përdoret dhe ku JO ───────────────────────────────────────────────────
 * Përdoret aty ku lista është një ZGJEDHJE ose një roster i sotëm: dropdown-at,
 * caktimet, prezenca, oraret, lista e re e pagave.
 *
 * NUK përdoret te harta id→emër. Një raport i marsit ka rreshta të njerëzve që
 * u larguan në prill; po ua hoqëm emrin nga harta, raporti nuk i fsheh — i
 * shfaq pa emër. Ai është regresion, jo pastrim.
 */

/** `true` kur punëtori nuk është shënuar joaktiv. Fusha që mungon = aktiv. */
export function isActiveWorker(w) {
  if (!w) return false;
  if (w.EmploymentStatus) return w.EmploymentStatus === 'active';
  return w.Active !== false && w.active !== false;
}

/** E kundërta, e shkruar hapur — `!isActiveWorker(null)` do të gënjente. */
export function isInactiveWorker(w) {
  return Boolean(w) && !isActiveWorker(w);
}

/** Vetëm punëtorët aktivë, duke ruajtur radhën. Pranon edhe `null`/`undefined`. */
export function activeWorkers(list) {
  return (Array.isArray(list) ? list : []).filter(isActiveWorker);
}

/**
 * A ishte i punësuar në një datë të caktuar — për raportet me periudhë.
 *
 * Statusi «joaktiv» s'ka datë brenda vetes: njeriu që u largua në prill duhet
 * të dalë te raporti i marsit dhe të mos dalë te ai i qershorit. Aty ku ekziston
 * `EmploymentEndDate`, kjo e vendos me datë e jo me flamur.
 */
export function wasEmployedOn(w, isoDate) {
  if (!w || !isoDate) return isActiveWorker(w);
  const day = String(isoDate).slice(0, 10);
  if (w.EmploymentTimeline) return employedOnTimeline(w.EmploymentTimeline, day);
  const start = String(w.HireDate ?? w.hire_date ?? '').slice(0, 10);
  const end = [w.EmploymentEndDate ?? w.employment_end_date, w.TerminationDate ?? w.termination_date].filter(Boolean).map(d => String(d).slice(0,10)).sort()[0] || '';
  if (start && start > day) return false;
  if (end && end < day) return false;
  return end ? true : isActiveWorker(w);
}

function employedOnTimeline(w, day) {
  if (w.hire_date && day < w.hire_date) return false;
  if ((w.inactive_periods || []).some(p => day > p.end_date && (!p.reactivated_on || day < p.reactivated_on))) return false;
  const contracts = (w.contracts || []).filter(c => !c.start_date || c.start_date <= day).sort((a,b) => (a.start_date || '').localeCompare(b.start_date || '') || a.id - b.id);
  const end = [w.employment_end_date, w.termination_date, contracts[contracts.length - 1]?.end_date].filter(Boolean).sort()[0];
  return !end || day <= end;
}
